import React from "react";

const NumberInput = ({ question, placeholder, multiline, value, onChange }) => {
  return (
    <div className="text-input-question">
      <h4 className="question-text mb-4">{question}</h4>
      {multiline ? (
        <textarea
          className="form-control"
          rows="6"
          placeholder={placeholder}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          style={{ fontSize: "16px" }}
        />
      ) : (
        <input
          type="number"
          className="form-control"
          placeholder={placeholder}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          style={{ fontSize: "16px", padding: "12px" }}
        />
      )}
      {value && (
        <div className="mt-2">
          <small className="text-muted">
            {value.length} characters
          </small>
        </div>
      )}
    </div>
  );
};

export default NumberInput;
